import { type Ref, computed, defineComponent } from 'vue'

interface Props {
  mainRef?: Ref<HTMLElement | null>
  tData?: string
  id?: string
  class?: unknown
  checked: boolean
  onClick?: ((payload: MouseEvent) => void)
}

export default defineComponent<Props>((props, context) => {
  // #region Getters

  const tData = computed(() => props.tData ?? 'v-tab-button')

  // #endregion

  return () => (
    <button
      ref={(ref) => {
        if (props.mainRef?.value !== undefined) {
          props.mainRef.value = ref as HTMLButtonElement
        }
      }}
      t-data={tData.value}
      id={props.id}
      class={['btn-tab btn-tab-primary uppercase', props.class]}
      type='button'
      aria-checked={props.checked}
      onClick={props.onClick}
    >
      {context.slots.default?.()}
    </button>
  )
}, {
  name: 'VTabButton',
  props: [
    'mainRef',
    'tData',
    'id',
    'class',
    'checked',
    'onClick'
  ]
})
